export default __webpack_public_path__ + "static/media/business_partner_4.c075bbc5.png";